import { Usuario } from "../../perfil";
import { ModalQrCodeProtegido } from "./modalQrCodeProtegido";

export const ModalQrCodeTri7 = ({ visible, onCancel }) => (
  <ModalQrCodeProtegido
    visible={visible}
    onCancel={onCancel}
    titulo="QR Code do Token Tri7"
    avisoMensagem="Este QR Code é a sua credencial de acesso Tri7"
    avisoDescricao="Quem fotografar a tela consegue gerar seus tokens. Escaneie apenas no seu próprio celular e não compartilhe a imagem."
    buscarQrCode={Usuario.getBuscarQrCodeTri7}
    mensagemErro="Não foi possível gerar o QR Code do token Tri7."
  />
);
